import { Container, Richtext } from '@volkswagen-onehub/components-core';
import React from 'react';
import { DisclaimerTextLegal } from '../../../shared/ui/disclaimer-text-legal';
import { HuchaDisclaimer1Text } from './hucha-disclaimers';

export const HuchaDisclaimer1Content = ({ isPDF = false }: { isPDF?: boolean }): React.JSX.Element => {
	return (
		<Container wrap={'always'}>
			<DisclaimerTextLegal isPDF={isPDF}>
				{'1. '}
				<Richtext dangerouslyParseRawHTML markdown={HuchaDisclaimer1Text} />
			</DisclaimerTextLegal>
		</Container>
	);
};
